module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-46.189d1869.png";